export interface IReportTemplateRow {
    title?: string;
    titleDe?: string;
    type?: IReportTemplateRowType;
    valueId?: string;
}

export enum IReportTemplateRowType {
    empty,
    input,
    select,
    checkbox,
    date,
    textarea,
    document
}
